import * as angular from "angular";
import * as _ from "lodash";
import {IController, ILogService} from "angular";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {AgentInventoryDialogService} from "../../../agent-inventory/angular/services/agent-inventory-dialog.service";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";
import {AgentInventoryService} from "../../../agent-inventory/services/agent-inventory-service.service";
import {AgentModel} from "../../angular/models/agent.model";
import {AgentInventoryActionType} from "../../../agent-inventory/types/agent-inventory-action.type";

export class AgentInventoryTransactionsViewComponent implements IController {

  agent: AgentModel;
  public filtersConfig;
  public infiniteScroll: any;
  public actionType: typeof AgentInventoryActionType = AgentInventoryActionType;
  public isLoadSelected: boolean = true;
  public isUnloadSelected: boolean = true;

  private transactionsRef: any;
  private loadLimit: number = 30;

  constructor(
    private $agentInventory,
    private $infiniteScroll,
    private $log: ILogService,
    private agentInventoryDialogService: AgentInventoryDialogService,
    private agentInventoryService: AgentInventoryService,
    private bringozToastService: BringozToastService
  ) {

  }

  $onInit() {
    // Initialize filters configuration
    this.filtersConfig = {
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.depotIds,
        SiteFiltersType.accountIds
      ],
      bringozFilters: {
        [SiteFiltersType.branchIds]: [],
        [SiteFiltersType.depotIds]: [],
        [SiteFiltersType.accountIds]: []
      }
    };

    this.transactionsRef = this.$agentInventory();
    this.transactionsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.transactionsRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

  onActionTypeSelect(actionType: AgentInventoryActionType) {
    if (actionType === AgentInventoryActionType.Load) {
      this.isLoadSelected = !this.isLoadSelected;
    }
    if (actionType === AgentInventoryActionType.Unload) {
      this.isUnloadSelected = !this.isUnloadSelected;
    }
    this._reload();
  }

  onFiltersChange(filters) {
    this.filtersConfig.bringozFilters = filters;
    this._reload();
  }

  openCreateDialog(event) {
    const locationType = undefined;
    const locationId = this.agent.id;
    const locationData = undefined;

    this.agentInventoryDialogService.createTransaction(event, locationType, locationId, locationData, this.agent.id)
      .then((transactionPayload) => {
        if (transactionPayload) {
          // Determine which method to call based on action type
          const apiCall = transactionPayload.actionType === 'Unload'
            ? this.agentInventoryService.createUnloadTransaction(transactionPayload)
            : this.agentInventoryService.createLoadTransaction(transactionPayload);

          apiCall
            .then(() => {
              this._reload();
            })
        }
      })
      .catch(() => {
        // Dialog was cancelled
      });
  }

  private _reload() {
    this.transactionsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      });
  }

  private _getQueryPayload() {
    const actionTypes = [];
    if (this.isLoadSelected) {
      actionTypes.push(AgentInventoryActionType.Load);
    }
    if (this.isUnloadSelected) {
      actionTypes.push(AgentInventoryActionType.Unload);
    }
    return {
      limit: this.loadLimit,
      actionTypes: actionTypes?.length ? actionTypes : undefined,
      locationIds: _.concat(this.filtersConfig.bringozFilters.accountIds, this.filtersConfig.bringozFilters.depotIds),
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      agentIds: [this.agent.id],
      sort: 'createdAt,desc'
    };
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentInventoryTransactionsView', {
    bindings: {
      agent: '<'
    },
    template: require('./agent-inventory-transactions-view.html').default,
    controller: AgentInventoryTransactionsViewComponent
  });

